/**
* @file 系统设置-机构名称
* */
<template>
  <div id="organization">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" addText="创建分支机构"
                  @addFn="$router.push('/organizationForm')">


      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="150px">
          <div slot-scope="{ row }" class="custom-action">
            <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click="edit(row)"></i>
            </el-tooltip>
            <template v-if="mixinUserInfo.platformType < 3">
              <el-tooltip content="合规信息" placement="top">
                <img src="./qiye.png" @click="compliance(row)"
                     style="width:18px;cursor: pointer;margin:0 10px;"/>
              </el-tooltip>
              <el-tooltip content="充值" placement="top">
                <i class="iconfont icon-caozuoanniu-chongzhi" @click="recharge(row)"></i>
              </el-tooltip>
            </template>
            <template v-if="mixinUserInfo.platformType == 3">
              <el-tooltip content="合作信息" placement="top">
                <i class="el-icon-document" style="font-size: 18px; color: #409EFF;" @click="info(row)"></i>
              </el-tooltip>
            </template>


            <el-tooltip content="客运监管" placement="top" v-if="btnPreFn('survey_merchant',false)">
              <i class="iconfont icon-jianguanhegui" @click="showSuperviseFn(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除机构" placement="top" v-if="row.type == 2">
              <i class="el-icon-delete delete-icon" @click="deleteOrg(row)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
            row.created | filterTime
          }}
        </template>
        <template v-else-if="item.prop === 'qrcode'">
          <el-button type="text" @click="showQrcode(row)">查看</el-button>
        </template>

        <template v-else-if="item.prop === 'name'">
          <div class="flex-start">
            <div style="border-radius: 5px;overflow: hidden;width: 25px; height: 25px;">
              <img :src="mixinQiniuImg(row.logo)" style="width: 25px; height: 25px;" alt=""/>
            </div>
            <div style="width: calc(100% - 25px - 10px);padding-left: 6px;box-sizing: border-box">{{
                row.name
              }}
            </div>
          </div>
        </template>
        <template v-else-if="item.prop === 'balance'">
          <span class="util-money" v-if="row.balance || row.balance === 0">{{
              row.balance
            }}</span>
          <span v-if="!row.balance && row.balance !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'type'">
          <el-tag v-if="row.type == 1">总公司</el-tag>
          <el-tag type="warning" v-else>子公司</el-tag>
        </template>
        <template v-else-if="item.prop === 'status'">
          <div class="custom-switch" @click="switchClick(row)">
            <el-switch disabled v-model="row.status" :active-value="1" :inactive-value="2"></el-switch>
          </div>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>

    <!--机构余额充值弹框-->
    <el-dialog title="机构余额充值" :visible.sync="visible" width="420px" :close-on-click-modal="false" class="recharge-dialog">
      <el-form label-position="top" :model="form" :rules="rules" ref="form" label-width="0">
        <el-form-item label="充值金额" prop="fee">
          <el-input
            v-model="form.fee"
            maxlength="10"
            placeholder="请输入充值的金额"
            oninput="value=value.replace(/[^\d.]/g,'').replace(/\.{2,}/g,'.').replace(/^(\d+)\.(\d{2}).*$/,'$1.$2')"
          >
            <template slot="prepend">¥</template>
            <template slot="append">元</template>
          </el-input>
          <p class="form-tip">充值的金额，用于平台代下单使用</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="postBannerTime" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="注册二维码" :visible.sync="show" width="400px" :close-on-click-modal="false">
      <div>
        <div class="flex-center download_material_down1">
          <vue-qr class="qr-code-down3" :text="qrcodeUrl" :margin="12" colorDark="#FF6633" height="220" width="220"/>
        </div>
        <div class="download_material download_material_down1">
          <img class="bg" :src="bg" alt="">
          <vue-qr class="qr-code download_material_code" :text="qrcodeUrl" :margin="12" colorDark="#FF6633" height="300"
                  width="300"/>
        </div>
        <div class="download_material1 download_material_down1">
          <img class="bg" :src="bg1" alt="">
          <vue-qr class="qr-code download_material_code" :text="qrcodeUrl" :margin="12" colorDark="#FF6633" height="280"
                  width="280"/>
          <vue-qr class="qr-code-down download_material_code1" :text="qrcodeText" :margin="11" colorDark="#7EBF50"
                  :size="350"/>
        </div>
        <div class="flex-center" style="margin-top: 20px">
          <el-button style="width: 100px" @click="show = false">取消</el-button>
          <el-button style="width: 100px" type="primary" @click="downloadAppPath">下载二维码</el-button>
        </div>
      </div>
    </el-dialog>


    <supervise :superviseId="superviseId" v-model="showSupervise"></supervise>

    <!-- 删除机构确认弹窗 -->
    <el-dialog
      title="删除分机构"
      :visible.sync="deleteVisible"
      width="500px"
      :close-on-click-modal="false"
      class="delete-org-dialog"
      @close="resetDeleteForm">
      <div class="delete-warning">
        <i class="el-icon-warning"></i>
        <span>此操作<strong>不可撤销</strong>，机构数据将永久删除，请谨慎操作</span>
      </div>
      <div class="delete-org-info">
        <div class="info-row">
          <span class="info-label">机构名称：</span>
          <span class="info-value">{{ deleteRow.fullName }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">机构简称：</span>
          <span class="info-value"><strong>{{ deleteRow.name }}</strong></span>
        </div>
        <div class="info-row">
          <span class="info-label">联系人：</span>
          <span class="info-value">{{ deleteRow.contactsName }}</span>
        </div>
      </div>
      <div class="delete-checklist">
        <div class="checklist-title"><i class="el-icon-info-solid"></i> 删除前系统将自动验证以下条件：</div>
        <ul>
          <li><i class="el-icon-circle-check"></i> 机构下无成员账号</li>
          <li><i class="el-icon-circle-check"></i> 机构下无司机信息</li>
          <li><i class="el-icon-circle-check"></i> 机构下无车辆信息</li>
          <li><i class="el-icon-circle-check"></i> 机构下无未完成订单</li>
        </ul>
      </div>
      <div class="delete-confirm-input">
        <p>请输入机构简称 <strong>"{{ deleteRow.name }}"</strong> 以确认删除：</p>
        <el-input
          v-model="deleteConfirmText"
          placeholder="请输入机构简称"
          clearable
          @keyup.enter.native="deleteConfirmText === deleteRow.name && confirmDelete()"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button
          type="danger"
          :disabled="deleteConfirmText !== deleteRow.name"
          :loading="deleteLoading"
          @click="confirmDelete">
          确认删除
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import supervise from './components/supervise'
import VueQr from "vue-qr";
import {download} from '@/assets/js/domToImgAndDownloadZip';

export default {
  name: "organization",
  components: {
    VueQr,
    supervise
  },
  data() {
    return {
      bg: require("@/assets/img/download_register.png"),
      bg1: require("@/assets/img/flow_chart.png"),
      show: false,
      showSupervise: false,
      deleteVisible: false,
      deleteRow: {},
      deleteConfirmText: '',
      deleteLoading: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/organization",
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
      },
      // 表头
      columns: [
        {prop: "fullName", label: "机构名称"},
        {prop: "name", label: "机构简称"},
        {prop: "organizationCode", label: "机构标识码"},
        {prop: "contactsName", label: "机构联系人"},
        {prop: "contactsPhone", label: "机构联系电话"},
        {prop: "type", label: "机构类型"},
        {prop: "balance", label: "机构余额"},
        {prop: "created", label: "创建时间"},
      ],
      // 设置轮播速度的弹框
      visible: false,
      // 设置轮播速度对象
      form: {},
      // 校验规则
      loading: false,
      rules: {
        fee: [
          {required: true, message: "请输入充值的金额"},
          {
            pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/,
            message: "请输入正确的金额",
          },
        ],
      },
      superviseId: '',
      qrcodeUrl: '',
      qrcodeText: ''
    };
  },
  created() {
    if (this.mixinUserInfo.platformType === 3 || this.mixinUserInfo.platformType === 4) {
      this.columns.push({prop: "qrcode", label: "司机注册二维码"})
      this.getAppDownload();
    }
  },
  methods: {
    async getAppDownload() {
      let url = "/api/v1/manage/appPath";
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data.driverPath) {
        this.qrcodeText = data.data.driverPath;
      }
    },
    downloadAppPath() {
      // let oQrcode = document.getElementsByClassName("qr-code-down3")[0];
      // let a = document.createElement("a");
      // console.log('oQrcode.src',oQrcode.src)
      // a.href = oQrcode.src;
      // a.download = "司机注册二维码";
      // a.click();
      this.$nextTick(() => {
        download(document.querySelectorAll(".download_material_down1"), ["司机注册二维码", "司机注册物料图", "司机认证物料图"]);
      })
    },
    async showQrcode(row) {
      const url = "/api/v1/manage/organization/qrcode/" + row.id;
      const {data, code} = await this.$axios.get(url);
      if (data && code === 1) {
        this.qrcodeUrl = `${data.url}/#/register?organizationId=${data.organizationId}&appKey=${data.appKey}&appPath=${data.appPath}`
        this.show = true
      }
    },
    /**
     * 列表-新增
     */
    addFn() {
      this.$router.push({path: "/organizationForm"});
    },
    showSuperviseFn(row) {
      this.superviseId = row.id
      this.showSupervise = true
    },
    deleteOrg(row) {
      this.deleteRow = { ...row };
      this.deleteConfirmText = '';
      this.deleteVisible = true;
    },
    resetDeleteForm() {
      this.deleteConfirmText = '';
      this.deleteRow = {};
    },
    async confirmDelete() {
      if (this.deleteConfirmText !== this.deleteRow.name) return;
      this.deleteLoading = true;
      try {
        const url = '/api/v1/manage/organization';
        const data = await this.$axios.delete(url, {
          id: this.deleteRow.id,
          appKey: this.mixinUserInfo.appKey
        });
        if (data && data.code === 1) {
          this.$message.success('机构已成功删除');
          this.deleteVisible = false;
          this.$refs.customTable.listFn();
        } else {
          this.$message.error(data.msg || '删除失败，请稍后重试');
        }
      } catch (e) {
        this.$message.error('删除请求失败，请稍后重试');
      } finally {
        this.deleteLoading = false;
      }
    },
    edit(row) {
      this.$router.push({
        path: "/organizationForm",
        query: {
          id: row.id,
          type: row.type
        }
      });
    },
    compliance(row) {
      this.$router.push({
        // path: row.type == 1 ? "/organizationMessage" : "/organizationMessageBranch",
        path: "/organizationMessage",
        query: {
          id: row.id,
          type: row.type
        }
      });
    },
    info(row) {
      this.$router.push({
        path: "/cooperateInfo",
        query: {
          id: row.id
        }
      });
    },
    recharge(row) {
      this.form = {
        id: row.id,
      };
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.visible = true;
    },
    postBannerTime() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let url = "/api/v1/manage/organization/recharge";
          let data = await this.$axios.post(url, this.form);
          this.loading = false;
          if (data && data.code === 1) {
            this.$refs.customTable.listFn();
            this.visible = false;
            this.$message.success("充值成功！");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less">
#organization {
  .search-top-left {
    font-weight: 600;

    .second {
      color: #999;
    }

    .set {
      margin-left: 10px;
    }
  }

  .el-input {
    width: auto;
  }

  .el-table .cell.el-tooltip {
    display: flex;
  }

  .download_material {
    width: 750px;
    height: 1620px;
    position: fixed;
    top: 9999px;
    left: 9999px;
    z-index: -1;

    .bg {
      width: 750px;
      height: 1620px;
    }

    .download_material_code {
      position: absolute;
      top: 533px;
      left: 226px;
    }
  }

  .download_material1 {
    width: 750px;
    height: 7030px;
    position: relative;
    position: fixed;
    top: 9999px;
    left: 9999px;
    z-index: -1;

    .download_material_code {
      position: absolute;
      top: 564px;
      left: 236px;
    }


    .download_material_code1 {
      position: absolute;
      bottom: 306px;
      left: 200px;
    }
  }

  // 删除图标
  .delete-icon {
    font-size: 18px;
    color: #F56C6C;
    cursor: pointer;
    transition: color 0.2s;
    &:hover { color: #c0392b; }
  }

  // 机构余额充值弹窗样式
  &.recharge-dialog,
  .recharge-dialog {
    .el-dialog__body {
      padding: 20px 24px 10px;
    }

    .el-form-item__label {
      font-weight: 500;
      color: #303133;
      padding-bottom: 8px;
    }

    .el-input-group__prepend,
    .el-input-group__append {
      background: #f5f7fa;
      color: #606266;
      border-color: #dcdfe6;
    }

    .el-input__inner {
      border-radius: 0;
    }

    .el-input-group__prepend {
      border-radius: 6px 0 0 6px;
    }

    .el-input-group__append {
      border-radius: 0 6px 6px 0;
    }

    .form-tip {
      font-size: 12px;
      color: #909399;
      margin-top: 8px;
      line-height: 1.5;
    }

    .dialog-footer {
      text-align: right;

      .el-button {
        min-width: 80px;
        border-radius: 6px;
      }
    }
  }
}

.delete-org-dialog {
  .delete-warning {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: #fff6f6;
    border: 1px solid #fbc4c4;
    border-radius: 6px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #606266;

    i { font-size: 20px; color: #F56C6C; flex-shrink: 0; }
    strong { color: #F56C6C; }
  }

  .delete-org-info {
    padding: 12px 16px;
    background: #f8f9fc;
    border-radius: 6px;
    margin-bottom: 16px;

    .info-row {
      display: flex;
      align-items: center;
      padding: 5px 0;
      font-size: 14px;

      .info-label { color: #909399; width: 80px; flex-shrink: 0; }
      .info-value { color: #303133; font-weight: 500; }
    }
  }

  .delete-checklist {
    margin-bottom: 20px;

    .checklist-title {
      font-size: 13px;
      color: #409EFF;
      font-weight: 600;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      gap: 6px 20px;

      li {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 13px;
        color: #606266;

        i { color: #67C23A; font-size: 14px; }
      }
    }
  }

  .delete-confirm-input {
    p {
      font-size: 13px;
      color: #606266;
      margin-bottom: 10px;

      strong { color: #F56C6C; }
    }
  }

  .el-dialog__footer .el-button {
    min-width: 80px;
    border-radius: 6px;
  }
}
</style>
